import { useEffect, useState } from "react";
import { PageTitle } from "@/components/studio/common";
import { Input } from "@/components/ui/input";
import { api, dt } from "@/lib/api";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/admin/audit", { params: { limit: 500 } }).then((r) => setRows(r.data)); }, []);
  const list = q ? rows.filter((r) => `${r.actor} ${r.action} ${r.entity_id}`.toLowerCase().includes(q.toLowerCase())) : rows;
  return (
    <div data-testid="audit-page">
      <PageTitle title="Audit log" sub="Registro immutabile delle operazioni su dati personali e pratiche" />
      <Input data-testid="audit-filter-input" placeholder="Filtra per utente, azione o ID" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-sm mb-4 bg-white" />
      <div className="bg-white border border-slate-200 rounded-xl overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500"><tr>{["Data", "Attore", "Azione", "Entità", "Dettagli", "IP"].map((h) => <th key={h} className="text-left px-4 py-3">{h}</th>)}</tr></thead>
          <tbody>
            {list.map((r) => (
              <tr key={r.id} className="border-t border-slate-100 align-top" data-testid={`audit-row-${r.id}`}>
                <td className="px-4 py-2.5 text-xs whitespace-nowrap">{dt(r.at)}</td><td className="px-4 text-xs">{r.actor}</td>
                <td className="px-4"><span className="font-mono text-xs bg-slate-100 rounded px-1.5 py-0.5">{r.action}</span></td>
                <td className="px-4 text-xs">{r.entity} <span className="font-mono text-slate-400">{r.entity_id?.slice(0, 8)}</span></td>
                <td className="px-4 font-mono text-[11px] text-slate-500 max-w-xs break-all">{Object.keys(r.details || {}).length ? JSON.stringify(r.details) : ""}</td>
                <td className="px-4 font-mono text-xs">{r.ip}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
